// @flow

import * as React from 'react';

import Group from 'sail/Group';
import {AttentionNotice, NegativeNotice, PositiveNotice} from 'sail/Notice';
import type {TailorComponentExample} from './index';

const presets: TailorComponentExample = {
  rendered: (
    <Group spacing={20}>
      <AttentionNotice
        title="Attention notice"
        description="Automatically sets the icon to a warning circle and the color to yellow."
      />

      <NegativeNotice
        title="Negative notice"
        description="Automatically sets the icon to a warning triangle and the color to red."
      />

      <PositiveNotice
        title="Positive notice"
        description="Automatically sets the icon to a checkmark and the color to green."
      />
    </Group>
  ),
  source: `<Group spacing={20}>
  <AttentionNotice
    title="Attention notice"
    description="Automatically sets the icon to a warning circle and the color to yellow."
  />

  <NegativeNotice
    title="Negative notice"
    description="Automatically sets the icon to a warning triangle and the color to red."
  />

  <PositiveNotice
    title="Positive notice"
    description="Automatically sets the icon to a checkmark and the color to green."
  />
</Group>`,
};

export {presets};
